export function locationIcon() {
	// intentionally blank, all plugin files are pulled from confluence via WRM
}

export function locationIconWRM() {
	// Attaches handler to editor precursor #rte-button-location icon.
	return ['wr!confluence.web.resources:deferred-dialog-loader'];
}
